import { render } from "./JFpublish.vue?vue&type=template&id=7f637458&scoped=true"
import script from "./JFpublish.vue?vue&type=script&lang=js"
export * from "./JFpublish.vue?vue&type=script&lang=js"

import "./JFpublish.vue?vue&type=style&index=0&id=7f637458&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f637458"]])

export default __exports__